class ImageModal {
  constructor() {
    this.modal = document.querySelector('.image-modal');
    this.modalImage = document.querySelector('.modal-image');
    this.triggers = document.querySelectorAll('.gallery-image-trigger');
    this.scrollPosition = 0;
    
    console.log('ImageModal constructor called');
    console.log('Modal element:', this.modal);
    console.log('Modal image element:', this.modalImage);
    console.log('Trigger elements:', this.triggers.length);
    
    if (this.modal && this.modalImage && this.triggers.length > 0) {
      this.init();
    } else {
      console.error('ImageModal: Required elements not found');
      if (!this.modal) console.error('Modal element not found');
      if (!this.modalImage) console.error('Modal image element not found');
      if (this.triggers.length === 0) console.error('Trigger elements not found');
    }
  }

  init() {
    console.log('ImageModal initialized');
    console.log('Triggers found:', this.triggers.length);
    console.log('Modal found:', !!this.modal);
    console.log('Modal image found:', !!this.modalImage);
    
    // 画像クリック時のイベントリスナーを追加
    this.triggers.forEach((trigger, index) => {
      console.log(`Adding click listener to trigger ${index}`);
      
      // 既存のイベントリスナーを削除してから追加
      trigger.removeEventListener('click', this.handleImageClick);
      trigger.addEventListener('click', this.handleImageClick.bind(this));
    });

    // モーダルを閉じる処理
    this.setupCloseHandlers();
  }

  handleImageClick(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Image clicked!');
    const img = e.currentTarget.querySelector('img');
    if (img) {
      console.log('Opening modal with image:', img.src);
      this.openModal(img);
    }
  }

  openModal(img) {
    // 現在のスクロール位置を保存
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    console.log('Scroll position saved:', this.scrollPosition);
    
    // 画像のsrcを設定
    this.modalImage.src = img.dataset.src || img.src;
    this.modalImage.alt = img.alt;
    
    // スクロールバーを調整
    this.adjustScrollbar();
    
    // モーダルを表示
    this.modal.classList.add('is-active');
    document.body.classList.add('is-fixed');
    
    // スクロール位置を固定
    document.body.style.top = `-${this.scrollPosition}px`;
  }

  closeModal() {
    this.modal.classList.remove('is-active');
    document.body.classList.remove('is-fixed');
    
    // スクロール位置を復元
    this.restoreScrollPosition();
  }

  setupCloseHandlers() {
    // 閉じるボタンをクリックしたとき
    const closeBtn = this.modal.querySelector('.btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    }

    // モーダル背景をクリックしたとき
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // ESCキーでモーダルを閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.closeModal();
      }
    });
  }

  // スクロールバーを調整
  adjustScrollbar() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  // スクロール位置を復元
  restoreScrollPosition() {
    // スクロールバーの調整を解除
    document.body.style.paddingRight = '';
    document.body.style.top = '';
    
    // スクロール位置を復元（requestAnimationFrameを使用してより確実に）
    requestAnimationFrame(() => {
      window.scrollTo(0, this.scrollPosition);
    });
  }
}